export const DELETE_ADDITIONAL_ACCOUNT_SUCCESS_TOAST = 'La cuenta ha sido eliminada exitosamente.';

/** Único `accountStatus` que se renderiza — `grouped-by-currency` ya aplica `account-status=ACTIVE` por default; el adapter filtra defensivo igual. */
export const ACTIVE_ADDITIONAL_ACCOUNT_STATUS = 'ACTIVE';

/**
 * `routeId` de una adicional cuya moneda no tiene principal de donde copiarlo. Ninguna ruta usa
 * el id 0: `useSelectAmount` cae a la ruta de la moneda, y `PaymentMethodList` conserva la de la
 * empresa, así que la adicional solo se ofrece si esa ruta tiene un método para cargarla.
 */
export const UNRESOLVED_ADDITIONAL_ACCOUNT_ROUTE_ID = 0;

/**
 * Branch de origen cuando ninguna cuenta del usuario trae uno: las adicionales llegan con el branch
 * vacío y el usuario puede no tener ninguna principal. Es el mismo default que `allowedBranch`
 * aplica a un branch vacío, así que el contacto se crea igual; sin él, el formulario no pide sus campos.
 */
export const DEFAULT_ORIGIN_BRANCH_NAME = 'B2B_GLOBAL_81';

/**
 * Estado de error de carga del listado real (ML-45): señal PERSISTENTE con
 * retry en vez de un toast autodescartable. Copys placeholder — no hay Figma
 * para este estado, confirmar con diseño antes de mergear.
 */
export const ADDITIONAL_ACCOUNTS_LOAD_ERROR_TITLE = 'No pudimos cargar tus cuentas';
export const ADDITIONAL_ACCOUNTS_LOAD_ERROR_BODY =
  'Ocurrió un problema al obtener tus cuentas secundarias. Vuelve a intentarlo.';
export const ADDITIONAL_ACCOUNTS_LOAD_ERROR_RETRY = 'Reintentar';

/** Texto real del Figma de ML-64 (drawer "Asignar usuarios"). */
export const ASSIGN_ADDITIONAL_ACCOUNT_USERS_SUCCESS_TOAST =
  'Has asignado correctamente un nuevo usuario a tu cuenta secundaria.';

/**
 * El Figma de ML-64 no especificó el copy de este toast (solo el diálogo de
 * confirmación) — placeholder a confirmar con diseño antes de mergear.
 */
export const REMOVE_ADDITIONAL_ACCOUNT_USER_SUCCESS_TOAST = 'Has quitado al usuario de la cuenta.';

/**
 * ML-3 — el fondeo inicial es asíncrono y su fallo NO revierte la creación
 * (`initialFunding: 'FAILED'`): la cuenta queda creada con saldo 0. Es una
 * advertencia, no un error: reintentar la creación duplicaría la cuenta, lo
 * que hay que reintentar es el ingreso de dinero.
 * COPY PROVISORIO — confirmar con diseño/PO: la HU no define este estado.
 */
export const CREATE_ADDITIONAL_ACCOUNT_FUNDING_FAILED_TOAST =
  'Creamos tu cuenta, pero no pudimos transferir el monto inicial. Puedes ingresar el dinero desde el detalle de la cuenta.';

/**
 * Ya NO hay una segunda llamada de asignación: los ids viajan en `userIds` del
 * propio create, así que "cuenta creada pero sin asignar" dejó de ser un estado
 * posible por fallo del backend.
 *
 * Sobrevive para un único caso, defensivo: que TODOS los ids preseleccionados se
 * descarten por no numéricos antes de armar el body (ver `toCreatableUserIds`).
 * Ahí la cuenta sí se crea y sí queda sin usuarios.
 * COPY PROVISORIO — confirmar con diseño/PO: la HU no define este estado.
 */
export const CREATE_ADDITIONAL_ACCOUNT_ASSIGN_FAILED_TOAST =
  'Creamos tu cuenta, pero no pudimos asignar los usuarios. Puedes asignarlos desde el detalle de la cuenta.';

/**
 * Prefijo del nombre visible de una cuenta primaria. Se completa con el nombre de la moneda
 * (`currencyName`) para que la cuenta se identifique sola fuera de un listado agrupado por
 * divisa: `Cuenta Principal - Peso Chileno`.
 */
export const PRIMARY_ACCOUNT_NAME_PREFIX = 'Cuenta Principal';

/** Copy de la rama `canCreate` de `AdditionalAccountsEmpty` cuando el llamador no pasa el suyo (Gestión y tab de wallet). */
export const ADDITIONAL_ACCOUNTS_EMPTY_COPY = {
  title: 'Organiza el dinero de tu empresa en cuentas secundarias',
  description:
    'Crea varias cuentas en una moneda, asigna presupuesto para viáticos, campañas o pagos, y controla quién accede, transacciona y usa las tarjetas de cada cuenta.',
  buttonText: '+ Crear tu primera cuenta',
} as const;

/** Copy de la rama `canCreate` de `AdditionalAccountsEmpty` en el Home, donde las cuentas adicionales se llaman secundarias. */
export const HOME_SECONDARY_ACCOUNTS_EMPTY_COPY = {
  title: 'Organiza el dinero de tu empresa en cuentas secundarias',
  description:
    'Crea varias cuentas en una moneda, asigna presupuesto para viáticos, campañas o pagos, y controla quién accede, transacciona y usa las tarjetas de cada cuenta.',
  buttonText: 'Crear cuenta',
  buttonIconLeft: 'regular plus',
} as const;

